module.exports = __webpack_public_path__ + "img/green-3.0f70fc94.svg";